import { fetchDateDueBreakDown } from "../../services/breakDownService";
import { dateDueBreakDownFetched } from "../actions/dateDueBreakDownAction";
import { createAllActionCreators } from "./actionCreatorUtil";

const dateDueBreakDownActionCreators = {
  dateDueBreakDownAction: {
    service: fetchDateDueBreakDown,
    action: dateDueBreakDownFetched,
  },
};

export const { dateDueBreakDownAction } = createAllActionCreators(
  dateDueBreakDownActionCreators,
);
